"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    accordionItemClassNames: function() {
        return accordionItemClassNames;
    },
    useAccordionItemStyles_unstable: function() {
        return useAccordionItemStyles_unstable;
    }
});
const _react = require("@griffel/react");
const accordionItemClassNames = {
    root: 'fui-AccordionItem'
};
const useAccordionItemStyles_unstable = (state)=>{
    'use no memo';
    state.root.className = (0, _react.mergeClasses)(accordionItemClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useAccordionItemStyles.styles.js.map
